import React from "react";
import { withRouter } from "react-router-dom";
import ThankyouImage from "../images/thankyou.svg";
import { Container } from "includes/Layouts";




 class BookingThankYou extends React.Component {

     bookingToken = '';

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.bookingToken =   localStorage.getItem('booking_token');
    }
    render() {

        return (
            <Container className="thank-page">
                <div>
                    <h1>Thank You!</h1>
                    <img src={ThankyouImage} />
                    <p>Your Booking has been submitted. </p>
                    <a href="/" className="btn btn-yellow">
                        Go to Homepage
                    </a>
                </div>
            </Container>
        );

    }
}
export default withRouter(BookingThankYou);
